import Observable from './observable';
function noop() { }
export default function switchLatest(stream) {
    let currentStream = undefined;
    let currentSubscription = undefined;
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return new Observable(function factory(observer) {
        const subscription = stream.subscribe({
            next(value) {
                if (value === currentStream) {
                    return;
                }
                if (currentSubscription) {
                    currentSubscription.unsubscribe();
                }
                currentSubscription = (currentStream = value).subscribe({
                    next(value) {
                        observer.next(value);
                    },
                    error(value) {
                        observer.error(value);
                    },
                    complete: noop,
                });
            },
            error(error) {
                observer.error(error);
            },
            complete() {
                observer.complete();
            },
        });
        return function unsubscribe() {
            subscription.unsubscribe();
            if (currentSubscription) {
                currentSubscription.unsubscribe();
            }
        };
    });
}
//# sourceMappingURL=switch-latest.js.map